/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;align-items:center;justify-content:center;height:100vh;width:100vw}.register-form[_ngcontent-%COMP%]{min-width:300px;background-color:#fff;opacity:.9;padding:20px;border:1px}a[_ngcontent-%COMP%]{line-height:32px}.message[_ngcontent-%COMP%], button[_ngcontent-%COMP%]{float:right}\n/*# sourceMappingURL=register-user.component.css.map*/"];
export { styles as styles };
